import { useState } from 'react';

export interface Stance {
  angle: string;
  diverge_toward?: string | null;
}

/**
 * TH-4 Three-Read Chorus — the stance/dissent chip. Progressive-disclosure
 * (chevron, not always-on): reveals the read's one-line `angle`. A divergent
 * read (diverge_toward set) is amber-tinted and exposes a ⤴ promote control
 * that spins the divergence off into its own sub-trail.
 */
export function StanceChip({ stance, onPromote }: { stance: Stance; onPromote: () => void }) {
  const [open, setOpen] = useState(false);
  const divergent = !!stance.diverge_toward;
  return (
    <div className="stance-chip text-xs">
      <button
        aria-label="toggle stance"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1 text-slate-500 dark:text-slate-400"
      >
        <span>{open ? '▾' : '▸'}</span>
        <span className={divergent ? 'text-amber-600 dark:text-amber-400' : ''}>
          {divergent ? 'divergent read' : 'read'}
        </span>
      </button>
      {open && (
        <div className="mt-1 pl-3 text-slate-600 dark:text-slate-300">
          <div>{stance.angle}</div>
          {divergent && (
            <div className="mt-0.5 text-amber-700 dark:text-amber-300">→ {stance.diverge_toward}</div>
          )}
        </div>
      )}
      {divergent && (
        <button
          aria-label="promote divergent read"
          onClick={onPromote}
          className="ml-1 text-amber-600 hover:text-amber-500 dark:text-amber-400"
        >
          ⤴
        </button>
      )}
    </div>
  );
}
